module.exports = __webpack_public_path__ + "static/media/brushsize.5ea64ff0.svg";